import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=34da983a&scoped=true"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"
import style0 from "./BaseCalendar.vue?vue&type=style&index=0&id=34da983a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da983a",
  null
  
)

export default component.exports